import { AdService, AdServiceContext } from './AdProvider';

const AdServiceProvider = AdService().AdServiceProvider;

export { AdServiceProvider, AdServiceContext };
